module.exports = __webpack_public_path__ + "static/media/rafa-khomsah-product-cover.10f357e0.png";